<template>
    <FormSection title="Physicians" :full-height="false" :application-id="referral.application">
        <template v-slot:content>
            <section class="row g-0 p-4 pb-0">
                <div class="col-12 py-2">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="form-group pe-4 col-5">
                            <label for="physician"> Physician </label>
                            <TypeaheadInput
                                placeholder="Start Typing"
                                :getData="getPhysicianList"
                                :value="physiciansData"
                                v-on:valueChanged="changePhysiciansData"
                            />
                        </div>
                        <div class="form-group col-7 mt-4">
                            <button class="btn btn-md btn-primary px-3" @click="addPhysician()">Add Physician</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 table-responsive-md table-responsive-sm table-responsive-lg">
                    <table class="table border border-gray">
                        <thead>
                            <tr class="bg-table-header">
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Work Phone</th>
                                <th>Fax Number</th>
                                <th>Email</th>
                                <th>Specialty</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading || isError || !hasData">
                            <!-- LOADING -->
                            <template v-if="isLoading">
                                <tr v-for="i of loadingCount" :key="i" class="table-loading">
                                    <td v-for="i of columns" :key="i">
                                        <span class="shimmer-loading"></span>
                                    </td>
                                </tr>
                            </template>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Physicians Found.</h3>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Contact list" :try-again="getPhysician" />
                                </td>
                            </tr>
                        </tbody>
                        <template v-else>
                            <tbody v-for="physician of physicians.items" :key="physician.id">
                                <EditPhysicianRow
                                    :physician="physician"
                                    :columns="columns"
                                    :referral="referral"
                                    :refresh-list="getPhysician"
                                    :referral-id="referralId"
                                />
                            </tbody>
                        </template>
                    </table>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EditPhysician.ts"></script>
